"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const styles_1 = require("./styles");
const office_ui_fabric_react_1 = require("office-ui-fabric-react");
const DateHelper_1 = require("../../lib/DateHelper");
const ImportForm = (props) => {
    const [fromDate, setFromDate] = react_1.useState(props.initialFromDate);
    const [toDate, setToDate] = react_1.useState(props.initialToDate);
    const days = 1 + ((toDate.getTime() - fromDate.getTime()) / (1000 * 3600 * 24));
    console.log(fromDate, toDate);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { style: styles_1.styles.controlWrapper },
            react_1.default.createElement(office_ui_fabric_react_1.DatePicker, { label: "Date From", firstDayOfWeek: office_ui_fabric_react_1.DayOfWeek.Monday, placeholder: "Select a date...", ariaLabel: "Select a date", styles: styles_1.styles.datePicker, isRequired: true, minDate: DateHelper_1.getStartOfWeek(DateHelper_1.daysAgo(30)), maxDate: toDate, showMonthPickerAsOverlay: true, value: fromDate, onSelectDate: d => {
                    if (d)
                        setFromDate(d);
                    props.onFromDateChanged(d);
                } }),
            react_1.default.createElement(office_ui_fabric_react_1.DatePicker, { label: "Date To", firstDayOfWeek: office_ui_fabric_react_1.DayOfWeek.Monday, placeholder: "Select a date...", ariaLabel: "Select a date", styles: styles_1.styles.datePicker, isRequired: true, minDate: fromDate, maxDate: new Date(), showMonthPickerAsOverlay: true, value: toDate, onSelectDate: d => {
                    if (d)
                        setToDate(d);
                    props.onToDateChanged(d);
                } })),
        react_1.default.createElement(office_ui_fabric_react_1.Text, { block: true },
            days,
            " days selected"),
        react_1.default.createElement(office_ui_fabric_react_1.Separator, null),
        react_1.default.createElement(office_ui_fabric_react_1.PrimaryButton, { styles: styles_1.styles.submitButton, text: "Start Import", disabled: false, onClick: props.onSubmit })));
};
exports.default = ImportForm;
